/** SQL Lab template helpers — catalog loaded from GET /ReportFunction/templates. */

/** @typedef {'tenant' | 'datavault'} DataSourceTarget */

export const DATA_SOURCE_TARGET_TENANT = 'tenant';
export const DATA_SOURCE_TARGET_DATAVAULT = 'datavault';

export function normalizeReportTemplates(templates = []) {
    return templates.map(t => ({
        key: t.key ?? t.Key,
        category: t.category ?? t.Category,
        categoryLabel: t.categoryLabel ?? t.CategoryLabel,
        label: t.label ?? t.Label,
        description: t.description ?? t.Description,
        defaultFunctionName: t.defaultFunctionName ?? t.DefaultFunctionName,
        suggestedViz: t.suggestedViz ?? t.SuggestedViz,
        sql: t.sql ?? t.Sql ?? '',
        dataSourceTarget: t.dataSourceTarget ?? t.DataSourceTarget
            ?? ((t.category ?? t.Category) === 'integration' ? DATA_SOURCE_TARGET_TENANT : DATA_SOURCE_TARGET_DATAVAULT),
    }));
}

export function applyFunctionTemplate(templateKey, schema = 'public', functionName = 'my_report_fn', templates = []) {
    const tpl = templates.find(t => (t.key ?? t.Key) === templateKey);
    const rawSql = tpl?.sql ?? tpl?.Sql;
    if (!rawSql) return '';
    const safeSchema = (schema || 'public').replace(/[^\w]/g, '') || 'public';
    const safeName = (functionName || 'my_report_fn').replace(/[^\w]/g, '_') || 'my_report_fn';
    return rawSql
        .replace(/\{\{schema\}\}/g, safeSchema)
        .replace(/\{\{function_name\}\}/g, safeName);
}

export function getTemplateSelectOptions(templates = [], categories = {}) {
    return Object.entries(categories).map(([catKey, meta]) => ({
        label: meta.label ?? meta.Label,
        options: templates
            .filter(tpl => (tpl.category ?? tpl.Category) === catKey)
            .map(tpl => ({
                value: tpl.key ?? tpl.Key,
                label: tpl.label ?? tpl.Label,
                title: tpl.description ?? tpl.Description,
            })),
    }));
}
